import styled from '@emotion/styled';
import { rem } from '@utils';

const Anchor = styled.span(
  ({ theme }) => `
  background: ${theme.palette.grey['100']};
  border-radius: 60px;
  color: ${theme.palette.grey['600']};
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  padding: ${rem(1)} ${rem(6)};
  transition: inherit;
  user-select: none;
  white-space: nowrap;
  position: relative;
  top: -1px;

  @media (max-width: 430px) {
    padding: ${rem(1)} ${rem(8)};
  }
`
);

const Reference = styled.a(
  ({ theme }) => `
  cursor: pointer;
  transition: 200ms ease;
  position: relative;

  &:hover {
    color: ${theme.palette.primary.main};
  }

  &:hover ${Anchor} {
    background: ${theme.palette.pink.bg};
    color: ${theme.palette.primary.dark};
  }

  &&.active {
    color: ${theme.palette.primary.dark};
  }  

  &&.active ${Anchor} {
    background: ${theme.palette.primary.dark};
    color: ${theme.palette.common.white};
  }

  * + ${Anchor} {
    margin-left: ${rem(4)};
  }

  * + .icon {
    margin-left: 2px;
    position: relative;
    top: 2px;
  }
`
);

const InlineChart = styled.span`
  display: block;
  width: 100%;
`;

export default {
  Anchor,
  InlineChart,
  Reference
};
